import React, { useState } from 'react';
import { DemographicsForm } from './DemographicsForm';
import { MedicalHistory } from './MedicalHistory';
import { CommunicationHistory } from './CommunicationHistory';
import { CampaignsSegmentation } from './CampaignsSegmentation';
import { LoyaltyBilling } from './LoyaltyBilling';
interface PatientDetailsProps {
  patientId: number;
}
export function PatientDetails({
  patientId
}: PatientDetailsProps) {
  const [activeTab, setActiveTab] = useState<'demographics' | 'medical' | 'communication' | 'campaigns' | 'loyalty'>('demographics');
  const tabs = [{
    id: 'demographics' as const,
    label: 'Demographics & Contact'
  }, {
    id: 'medical' as const,
    label: 'Medical Records'
  }, {
    id: 'communication' as const,
    label: 'Communication History'
  }, {
    id: 'campaigns' as const,
    label: 'Campaigns & Segmentation'
  }, {
    id: 'loyalty' as const,
    label: 'Loyalty & Billing'
  }];
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200" data-id="element-1312">
      {/* Tabs */}
      <div className="border-b border-gray-200" data-id="element-1313">
        <div className="flex overflow-x-auto" data-id="element-1314">
          {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`px-6 py-3 text-sm font-medium whitespace-nowrap ${activeTab === tab.id ? 'text-green-600 border-b-2 border-green-600' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-1315">
              {tab.label}
            </button>)}
        </div>
      </div>
      {/* Tab Content */}
      <div className="p-6" data-id="element-1316">
        {activeTab === 'demographics' && <DemographicsForm patientId={patientId} data-id="element-1317" />}
        {activeTab === 'medical' && <MedicalHistory patientId={patientId} data-id="element-1318" />}
        {activeTab === 'communication' && <CommunicationHistory patientId={patientId} data-id="element-1319" />}
        {activeTab === 'campaigns' && <CampaignsSegmentation patientId={patientId} data-id="element-1320" />}
        {activeTab === 'loyalty' && <LoyaltyBilling patientId={patientId} data-id="element-1321" />}
      </div>
    </div>;
}